/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import { GET_STATIC_CHART_GQL } from '@/graphql/static-queries.gql';

export default {
  namespaced: true,

  state: {
    // = data
    staticCount: [],
  },

  mutations: {
    SET_STATIC_COUNT(state, payload) {
      state.staticCount.push(payload.count);
    },
  },

  actions: {
    getStaticCount({ commit }) {
      const querySubscription = apolloClient
        .subscribe({
          query: GET_STATIC_CHART_GQL,
          result({ data }) {
            console.log('data :', data);
          },
        })
        .subscribe({
          next(response) {
            console.log('data :', response.data);
            commit('SET_STATIC_COUNT', response.data);
          },
        });

      setTimeout(() => {
        querySubscription.unsubscribe();
        console.log('Subscription Stopped');
      }, 60000);
    },
  },

  getters: {
    // = computed properties
    staticCount: state => state.staticCount,
  },
};
